<template>
  <div id="schrittanzeige">

    <div class="row mb-md-5 mb-4">
      <div class="col-12 col-lg-8 offset-lg-2">
        <div class="form-step-container">

          <template v-for="n in last">
            <div v-if="n !== last"
                 :key="n+'-icon'"
                 class="form-step-box"
                 :class="{'form-box-active' : step === n }"
            >
              {{ n }}
            </div>
            <div v-if="n !== last"
                 :key="n+'-line'"
                 class="form-step-line"
                 :class="{'form-box-active' : step === n }">
            </div>
            <div v-else
                 :key="n+'-icon-end'"
                 class="form-step-box"
                 :class="{'form-box-end' : step === n }">
              <i class="fa fa-check" aria-hidden="true"></i>
            </div>
          </template>

        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-lg-8 offset-lg-2">
        <p v-html="title" class="form-info-text"/>
      </div>
    </div>

  </div>
</template>
<script>
import General from '@/mixins/general';

export default {
  mixins: [General],
  props: ['step','last', 'title'],
}
</script>
